import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext, ApplicationContext } from './ApplicationContext';
import { MessengerClient,IMessengerClientProps } from './components/MessengerClient';
import './custom.css';


/*
import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
*/



export const App = (props) => {

    const location = useLocation();
    
    let start = location.pathname.toLowerCase().substring(1).split('/');

    //console.log("location",{location: location, start: start});

    var parameters : IMessengerClientProps = {};

    if(start.length === 2 ) { //dialog/{dialogId}
        
        parameters[start[0]] = start[1];
            
    } else if(start.length === 4) { //dialog/{dialogId}/session/{sessionId}
         parameters[start[0]] = start[1];
         parameters[start[2]] = start[3];
    }

    const [context, setContext] = useState<ApplicationContext>(new ApplicationContext(location));


    

    return (
        <>
            <AppContext.Provider value={context} >
                <MessengerClient {...parameters} />
            </AppContext.Provider>
        </>
    );
    
}




/*
export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>
            </Layout>
        );
    }
}
*/